import { render, staticRenderFns } from "./FormMenu.vue?vue&type=template&id=095821b6&scoped=true"
import script from "./FormMenu.vue?vue&type=script&lang=js"
export * from "./FormMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095821b6",
  null
  
)

export default component.exports